module.exports = __webpack_public_path__ + "img/2.f6bce19c.png";